import { UserFormData } from "@repo/types";
import { InfoIcon } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { Card, CardContent, CardHeader, CardTitle } from "../../../../components/ui/card";
import { Checkbox } from "../../../../components/ui/checkbox";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from "../../../../components/ui/form";

type FormValues = UserFormData & { confirmPassword?: string };

interface UserSettingsSectionProps {
  form: UseFormReturn<FormValues>;
}

interface ToggleFieldProps {
  name: "is_active" | "email_active";
  label: string;
  description: string;
  form: UseFormReturn<FormValues>;
}

function ToggleField({ name, label, description, form }: ToggleFieldProps) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <div className="flex items-start space-x-3 p-4 rounded-lg border border-border bg-muted/40 hover:bg-muted transition-colors">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
                className="mt-1"
              />
            </FormControl>
            <div className="space-y-1">
              <FormLabel className="text-sm font-medium leading-none cursor-pointer">
                {label}
              </FormLabel>
              <FormDescription className="text-xs text-muted-foreground">
                {description}
              </FormDescription>
            </div>
          </div>
        </FormItem>
      )}
    />
  );
}

export function UserSettingsSection({ form }: UserSettingsSectionProps) {
  return (
    <Card className="shadow-sm">
      <CardHeader className="pb-4">
        <CardTitle className="flex items-center gap-2 text-lg">
          <InfoIcon className="h-5 w-5 text-primary" />
          Paramètres du compte
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground mb-6">
          Configurez les permissions et le statut de l'utilisateur
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ToggleField
            form={form}
            name="is_active"
            label="Compte actif"
            description="L'utilisateur peut se connecter et accéder à l'application"
          />
          <ToggleField
            form={form}
            name="email_active"
            label="Email vérifié"
            description="L'adresse email de l'utilisateur a été confirmée"
          />
        </div>
      </CardContent>
    </Card>
  );
}
